import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MntStoresRoutingModule } from './mnt-stores-routing.module';
import { StoresComponent } from './stores/stores.component';
import { MntMasterModule } from "../mnt-master/mnt-master.module";
// import { MasterLayoutComponent } from '../mnt-master/master-layout/master-layout.component'
// import { MasterMenuComponent } from '../mnt-master/master-menu/master-menu.component'
import { AppMaterialModule } from '../app-material/app-material.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CreateStoreComponent } from './create-store/create-store.component';
import { SharedModule } from "../shared/shared.module";
import { StoreProductPriceComponent } from './store-product-price/store-product-price.component';
import { StoreOrderListComponent } from './store-order-list/store-order-list.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { PrintLabelComponent } from './print-label/print-label.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { ArchiveListComponent } from './archive-list/archive-list.component';
import { RefundOrderComponent } from './refund-order/refund-order.component';
import { CopyDialogComponent } from './copy-dialog/copy-dialog.component';
import { CustomerNotificationComponent } from './customer-notification/customer-notification.component';
import { ShippingLabelsComponent } from './shipping-labels/shipping-labels.component';
import { CustomerOrdersComponent } from './customer-orders/customer-orders.component';
import { FlashMessagesModule } from "angular2-flash-messages";
import { QRCodeModule } from 'angularx-qrcode';
//import{MntInvoicesModule} from '../mnt-invoices/mnt-invoices.module';

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,   
    ReactiveFormsModule,
    FormsModule,
    MntStoresRoutingModule,
    MntMasterModule,
    SharedModule,
    FlashMessagesModule,
    QRCodeModule,
    //MntInvoicesModule
  ],  
  declarations: [
    StoresComponent,
    CreateStoreComponent,
    StoreProductPriceComponent,
    StoreOrderListComponent,
    CustomerListComponent,
    PrintLabelComponent,
    CustomerDetailComponent,
    ArchiveListComponent,
    RefundOrderComponent,
    CopyDialogComponent,
    CustomerNotificationComponent,
    ShippingLabelsComponent,
    CustomerOrdersComponent,
    // MasterLayoutComponent,
    // MasterMenuComponent
  ],
  entryComponents: [
    CreateStoreComponent,
    StoreProductPriceComponent,
    PrintLabelComponent,
    CustomerDetailComponent,
    RefundOrderComponent,
    CustomerNotificationComponent,
    CopyDialogComponent
  ]
})
export class MntStoresModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/mnt-stores.module.ts